import { color as themeColor } from '../../../app/theme';

function IconClock({ className, backgroundColor = themeColor.$24 }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 2.5C5.84091 2.5 2.5 5.84091 2.5 10C2.5 14.1591 5.84091 17.5 10 17.5C14.1591 17.5 17.5 14.1591 17.5 10C17.5 5.84091 14.1591 2.5 10 2.5ZM9.99989 16.1364C6.5908 16.1364 3.86353 13.4091 3.86353 10C3.86353 6.59092 6.5908 3.86365 9.99989 3.86365C13.409 3.86365 16.1363 6.59092 16.1363 10C16.1363 13.4091 13.409 16.1364 9.99989 16.1364ZM12.5227 12.5227C12.7955 12.25 12.7955 11.8409 12.5227 11.5682L10.6818 9.72727V5.90909C10.6818 5.5 10.4091 5.22727 10 5.22727C9.59091 5.22727 9.31818 5.5 9.31818 5.90909V10C9.31818 10.2045 9.38636 10.3409 9.52273 10.4773L11.5682 12.5227C11.7045 12.6591 11.8409 12.7273 12.0455 12.7273C12.25 12.7273 12.3864 12.6591 12.5227 12.5227Z"
        fill={backgroundColor}
      />
    </svg>
  );
}

export default IconClock;
